import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { ModalCard, useCreateModal } from 'partial/components/Modal';
import Button from 'partial/components/Button';
import FormTextArea from 'partial/components/form/FormTextArea';
import { useSendMessage } from '../hooks';

export const useOpenSendMessage = () => {
  const createModal = useCreateModal();

  const openSendMessageModal = useCallback(
    (data) => {
      createModal({
        content: (close) => <SendMessage data={data} onClose={close} />,
      });
    },
    [createModal],
  );

  return openSendMessageModal;
};

function SendMessage({ onClose, data }) {
  const [state, setState] = useState({ content: '' });
  const [isLoading, send] = useSendMessage(onClose);

  const submit = () => {
    send({ uuid: data?.uuid, content: state.content });
  };

  return (
    <ModalCard size="sm" title="SEND MESSAGE" onClose={onClose}>
      <div className="p-5 w-full">
        <FormTextArea
          name="content"
          onChange={setState}
          value={state.content}
          label="Add Message"
          placeholder="Type your text here"
          required
        />
        <div className="flex gap-2 justify-end mt-10">
          <Button className="uppercase" onClick={onClose}>
            cancel
          </Button>
          <Button
            outline
            className="uppercase"
            onClick={submit}
            disabled={state.content.length === 0 || isLoading}
          >
            confirm
          </Button>
        </div>
      </div>
    </ModalCard>
  );
}

SendMessage.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default SendMessage;
